import { XHRClient } from './xhr-client';

type QueryData = { [value: string]: any };

export class CuttingXHRClient extends XHRClient {
  private _publicApiKey = '';
  private _orderId = 0;

  constructor(publicApiKey: string, orderId: number) {
    super();
    this._publicApiKey = publicApiKey;
    this._orderId = orderId;
  }

  protected setHeaders(): void {
    this.xhr.setRequestHeader('Public-API-Key', this._publicApiKey);
  }

  private setOrderIdToQueryData(data: QueryData): QueryData {
    if (!data) {
      data = {};
    }

    data.orderId = this._orderId;

    return data;
  }

  post<T>(url: string, data?: QueryData): Promise<T> {
    data = this.setOrderIdToQueryData(data);

    return super.post(url, data);
  }

  get<T>(url: string, queryParams?: QueryData): Promise<T> {
    queryParams = this.setOrderIdToQueryData(queryParams);

    return super.get(url, queryParams);
  }
}
